import React from 'react';

const UserPreferencesContext = React.createContext({
  userPreferences: {}
});

export default UserPreferencesContext;
